<template>
  <Header />
  <Blogs />
  <Footer />
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Blogs from "@/components/Blogs.vue";
export default {
  components: {
    Blogs,
    Header,
    Footer,
  },
};
</script>
